import t from 'transit-js';

const registry = t.map();

export default registry;
